//Master Data: columns of the ESG student level list
const masterTableFields = [
    {title: "User Id",
        class_name: 'w-110p',
        field: {name: "user_id"},
        fetch_key: "user_id"
    },
    {title: "Name",
        field: {name: "name"},
        fetch_key: "name"
    },
    {title: "Email",
        field: {name: "email"},
        fetch_key: "user_email.email"
    },
    {title: "Mobile Number",
        class_name: 'w-250p',
        field: {name: "mobile_number"},
        fetch_key: "user_mobile.full_mobile"
    },
    {title: "School",
        field: {name: "school_id"},
        fetch_key: "school_name"
    },
    {title: "Branch",
        field: {name: "branch_id"},
        fetch_key: "branch_name"
    },
    {title: "Class",
        field: {name: "class_id"},
        fetch_key: "class_name"
    },
    {title: "ESG Levels",
        class_name: 'w-200p',
        field: {name: "esg_levels"},
        fetch_key: "esg_levels"
    }
];

// Filter panel (button + floating panel, same concept as Filter Auditors)
const filterTableData = [
    {colMd: "3", label: "User Id", type: "text", name: "user_id"},
    {colMd: "3", label: "Name", type: "text", name: "name"},
    {colMd: "3", label: "Email", type: "text", name: "email"},
    {colMd: "3", label: "ESG Level", type: "multi-select", name: "esg_level_id"},
    {colMd: "3", label: "School", type: "multi-select", name: "school_id"},
    {colMd: "3", label: "Branch", type: "multi-select", name: "branch_id"},
    {colMd: "3", label: "Class", type: "multi-select", name: "class_id"},
];

// Update form for the selected rows (or pasted user ids / emails)
const fieldValuesLevel = {
    ref_ids: '',
    ref_ids_array: [],
    level_id: []
};

const fieldUpdateLevel = [
    {colMd: "4", label: "ESG Level", required: true, type: "multi-select", name: "level_id", placeholderData: ["Select Level(s)"]},
    {colMd: "8", label: "User Ids / Emails", required: true, type: "text", name: "ref_ids", placeholderData: ["Select rows below, or type user ids / emails separated by comma"]},
];

const fieldValidationLevel = {
    level_id: 'required||ESG Level',
    ref_ids: 'required||User Ids / Emails'
};

// Excel upload modal
const fieldValuesExcel = {
    excel_file: '',
    excel_file_data: ''
};

const fieldExcelLevel = [
    {colMd: "12", required: true, label: "Excel File", type: "file", name: "excel_file", file_type: ".xlsx, .xls", tagline: "Please populate the downloaded Template File (user_id or email, and level per row: L1, L2, L3 or a combination such as L1+L2) and upload it. Keep row 1 (headings) and row 2 (instruction) as they are and fill the data from row 3."}
];

const fieldValidationExcel = {
    excel_file: 'required'
};

const data = {
    masterTableFields,
    filterTableData,
    fieldValuesLevel,
    fieldUpdateLevel,
    fieldValidationLevel,
    fieldValuesExcel,
    fieldExcelLevel,
    fieldValidationExcel
};

export default data;
